export default function CourseBannerGraphic(props: React.ComponentProps<'svg'>): JSX.Element {
  return (
    <svg width={348} height={224} viewBox="0 0 348 224" fill="none" {...props}>
      <g clipPath="url(#clip0)">
        <path
          d="M102.5 117l-1.391-6.388A21.4 21.4 0 0086 94.564l.795-.458A33.206 33.206 0 00102.5 73l.186.83A30.575 30.575 0 00119 94.563a25.533 25.533 0 00-15.093 17.126L102.5 117z"
          fill="bg"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M99.53 105.983a21.334 21.334 0 011.579 4.629L102.5 117l1.407-5.31a25.497 25.497 0 012.175-5.519A25.545 25.545 0 01119 94.564a30.566 30.566 0 01-16.314-20.735L102.5 73a33.165 33.165 0 01-3.48 8.821 33.214 33.214 0 01-12.225 12.285l-.795.458a21.369 21.369 0 016.455 3.055c3.032 2.12 5.478 5 7.075 8.364zm-2.278-12.267c2.2 1.75 4.121 3.83 5.691 6.166a31.529 31.529 0 015.094-5.569 36.62 36.62 0 01-5.703-6.52 39.197 39.197 0 01-5.082 5.923z"
          fill="bg.muted"
        />
        <path
          d="M238.804 191.411a28.043 28.043 0 00-11.033 12.895 23.91 23.91 0 00-11.353-13.247 35.709 35.709 0 0010.97-13.28 33.08 33.08 0 0011.416 13.632z"
          fill="bg"
          stroke="border.muted"
          strokeWidth={5}
        />
        <path
          d="M33 117l-2.781-12.777A42.8 42.8 0 000 72.129l1.59-.918A66.412 66.412 0 0033 29l.372 1.659A61.15 61.15 0 0066 72.129a51.07 51.07 0 00-30.186 34.251L33 117z"
          fill="bg"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M30.203 104.149l.016.074L33 117l2.814-10.62A51.075 51.075 0 0166 72.129a61.16 61.16 0 01-32.628-41.47L33 29a66.34 66.34 0 01-3.374 10.368A66.419 66.419 0 011.59 71.211L0 72.129a42.916 42.916 0 017.155 2.725 42.805 42.805 0 0123.048 29.295zM12.667 70.987a48.825 48.825 0 0120.956 24.001 57.089 57.089 0 0120.19-23.205 67.17 67.17 0 01-21.061-24.93 72.422 72.422 0 01-20.085 24.134z"
          fill="bg.muted"
        />
        <path
          d="M55 175l-1.817-8.253A28.492 28.492 0 0033 145.426l1.19-.68A43.66 43.66 0 0055 117l.21.93A40.57 40.57 0 0077 145.426a33.945 33.945 0 00-20.164 22.723L55 175z"
          fill="bg"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M52.136 163.141a28.538 28.538 0 011.047 3.606L55 175l1.836-6.851a34.02 34.02 0 011.676-4.789A33.953 33.953 0 0177 145.426a40.578 40.578 0 01-21.79-27.496L55 117a43.64 43.64 0 01-3.416 9.372 43.666 43.666 0 01-17.393 18.374l-1.191.68a28.456 28.456 0 016.824 2.9 28.501 28.501 0 0112.312 14.815zm-7.203-18.667a34.517 34.517 0 0110.586 11.666 39.968 39.968 0 019.932-11.005 46.58 46.58 0 01-10.63-12.254 49.677 49.677 0 01-9.888 11.593z"
          fill="bg.muted"
        />
        <path
          d="M352.319 164.773l30.143 72.773-30.143 72.773-72.773 30.143-72.773-30.143-30.144-72.773 30.144-72.773 72.773-30.144 72.773 30.144z"
          fill="bg.subtle"
          stroke="border.muted"
          strokeWidth={7}
        />
        <circle cx={353} cy={-4} r={70} fill="bg.subtle" stroke="border.muted" strokeWidth={6} />
      </g>
      <defs>
        <clipPath id="clip0">
          <path fill="bg" d="M0 0H348V224H0z" />
        </clipPath>
      </defs>
    </svg>
  )
}
